window.site = (window.site || {});

/**
 * Init script
 * @class Site
 * @static
 */
site.ContactForm = (function ContactForm() {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $formContact = document.querySelector('.contact-form');
    const $formContactClassique = document.querySelector('.contact-form-cta');
    const $formOverlay = document.querySelector('.contact-form-overlay');
    const $closeBtn = document.querySelector('.close-contact-btn');

    const $dynamiqueForm = document.querySelectorAll('[data-contact-form]');
    const $partnerFormsBtn = document.querySelector('[data-partner-form]');
    const $spontaneousFormsBtn = document.querySelector('[data-spontaneous-form]');
    const $dynamiqueFormClassique = document.querySelectorAll('[data-contact-form-classique]');

    if ($dynamiqueForm) {
      $dynamiqueForm.forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();

          $formContact.classList.add('is-active');
          $formOverlay.classList.add('is-active');
        });
      });
    }

    if ($dynamiqueFormClassique) {
      $dynamiqueFormClassique.forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();

          $formContactClassique.classList.add('is-active');
          document.querySelector('#contact-form-classique').classList.remove('is-active');
          document.querySelector('.classique-form-texts').classList.remove('is-active');
        });
      });

    }

    if ($formOverlay) {
      $formOverlay.addEventListener('click', (e) => {
        e.preventDefault();
        $formContact.classList.remove('is-active');
        $formOverlay.classList.remove('is-active');
      });
    }

    if ($closeBtn) {
      $closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        $formContact.classList.remove('is-active');
        $formOverlay.classList.remove('is-active');
      });
    }

    if ($partnerFormsBtn) {
      $partnerFormsBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.partner-form').classList.add('is-active');
      });
    }

    if ($spontaneousFormsBtn) {
      $spontaneousFormsBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.spontaneous-form').classList.add('is-active');
      });
    }


    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
